import React, {
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from "react";
import styled from "styled-components";
import { getDistance } from "../functions/getDistance";
import lang from "../functions/lang";
import { sortStores } from "../functions/sortStores";
import { Store } from "../interfaces/IStore";
// Importing the locate me icon
import { AppContext } from "./AppContext";
import AirbnbResults from "./Icons/AirbnbResults";
import FiltersIcon from "./Icons/FiltersIcon";
import HotelResults from "./Icons/HotelResults";
import MinusIcon from "./Icons/MinusIcon";
import PlusIcon from "./Icons/PlusIcon";
import StoreResults from "./Icons/StoreResults";
import TargetIcon from "./Icons/Target";
import XIconWhite from "./Icons/XIconWhite";
import { LocateMeButton } from "./LocateMeButton";
import { MapContext } from "./MapContext";
import { MobileFilterTemplate } from "./MobileFilterTemplate";
import { MobileResultsList } from "./MobileResultsList";
import MobileStoreCard from "./MobileStoreCard";
import { SearchBar } from "./SearchBar";

const SearchBarWrapper = styled.div`
  margin-top: 18px;
  position: absolute;
  z-index: 2;
  display: flex;
  justify-content: center;
  width: 100vw;
`;
const SearchBarContainer = styled.div`
  height: auto;
  display: flex;
  justify-content: center;
  flex-flow: row;
  align-items: center;
  background: transparent;
  width: calc(100% - 2 * 1.6rem);
  border-radius: 28px;
`;

const SearchBarInnerWrapper = styled.div`
  height: auto;
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: center;
  background: transparent;
  width: 100%;
  border-radius: 28px;
`;

const FindMyLocationWrapper = styled.div`
  background-color: white;
  padding: 8px;
  border-radius: 50%;
  height: 50px;
  min-width: 50px;
  box-shadow: rgb(0 0 0 / 25%) 5px 8px 15px;
  margin-right: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CircularFilterWrapper = styled.div`
  position: absolute;
  bottom: 0.6rem;
  z-index: 1;
  height: 6rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CircularFilterIcon = styled.div`
  border-radius: 50%;
  background-color: #522398;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 800;
  width: 70px;
  height: 70px;
`;

const LocateWrapper = styled.div`
  position: absolute;
  z-index: 1;
  top: 1px;
  right: 70px;
`;
const SearchShadow = styled.div`
  box-shadow: 0 1px 7px 0 rgb(0 0 0 / 20%);
  width: 100%;
  border-radius: 28px;
`;

const FilterContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: calc(100% - 2 * 1.6rem);
  position: absolute;
  bottom: 6.5rem;
  z-index: 4;
  background-color: white;
  height: auto;
  box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.25);
  border-radius: 33px;
  height: auto;
  max-height: 27.5rem;
  left: 50%;
  transform: translate(-50%);
`;

const FilterWrapper = styled.div`
  max-width: calc(100%);
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FilterHeader = styled.div`
  height: 3.6rem;
  background-color: white;
  color: #522398;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 1.5rem;
  cursor: pointer;
  border-bottom: 1px solid #c0bebe;
  flex-shrink: 0;
  flex-grow: 0;
`;
const FilterTitle = styled.h4`
  font-size: 1.1rem;
  font-weight: 700;
  letter-spacing: -0.8px;
  flex-shrink: 0;
  flex-grow: 0;
`;

interface IOverlay_Mobile {
  showStore: boolean;
  setShowStore: (showStore: boolean) => void;
  showFilter: boolean;
  setShowFilter: (showFilter: boolean) => void;
}

export const Overlay_Mobile = ({
  showStore,
  setShowStore,
}: PropsWithChildren<IOverlay_Mobile>) => {
  const [toggleFilter, setToggleFilter] = useState<boolean>(false);

  const {
    globalIndividualStore,
    setSearchResultCoords,
    setGlobalIndividualStore,
    stores,
    selectedStore,
    setSelectedStore,
    setIsSelectFromMap,
  } = useContext(AppContext);

  const {
    productFiltersGlobal,
    businessFiltersGlobal,
    setBusinessFiltersGlobal,
    setProductFiltersGlobal,
  } = useContext(AppContext);

  const [showProductTypes, setShowProductTypes] = useState<boolean>(false);
  const [showBusinessTypes, setShowBusinessTypes] = useState<boolean>(false);
  const [showResults, setShowResults] = useState<boolean>(true);
  const {
    currentStore,
    setCurrentStore,
    setCoords,
    setSortCoords,
    setDefaultZoom,
  } = useContext(MapContext);
  const [fromFilter, setFromFilter] = useState<boolean>(false);
  const handleBusinessFormChange = (e: InputEvent) => {
    const target = e.target as HTMLInputElement;
    if (businessFiltersGlobal !== target?.value)
      setBusinessFiltersGlobal(target.value);
    else setBusinessFiltersGlobal(undefined);
  };

  const handleProductFormChange = (e: InputEvent) => {
    const target = e.target as HTMLFormElement;
    let isInArray = productFiltersGlobal.some(
      (filter) => filter == target.value
    );

    if (!isInArray && target?.checked) {
      setProductFiltersGlobal([...productFiltersGlobal, target.value]);
    } else {
      setProductFiltersGlobal(
        productFiltersGlobal.filter((filter) => filter !== target.value)
      );
    }
  };

  useEffect(() => {
    if (currentStore && !toggleFilter) {
      setToggleFilter((toggleFilter) => !toggleFilter);
    }
  }, [currentStore]);

  useEffect(() => {
    if (showStore) {
      setShowBusinessTypes(false);
      setShowProductTypes(false);
    }
  }, [showStore]);

  const handlePrevStore = () => {
    const index = stores.findIndex(
      (store) => store.name_en == globalIndividualStore?.name_en
    );
    setGlobalIndividualStore(stores[index - 1]);
  };

  const expandStoreInfo = (
    e: any,
    latitude: number,
    longitude: number,
    name: string,
    store: any
  ) => {
    setShowStore(true);

    setSelectedStore(name);
    const newCoords = {
      lat: latitude,
      lng: longitude,
    };
    setGlobalIndividualStore(store);
    setSearchResultCoords(newCoords);
    setIsSelectFromMap(false);
  };

  const [size, setSize] = useState(
    window.innerWidth <= 770 ? "mobile" : "desktop"
  );

  const [searchError, setSearchError] = useState<boolean>(false);

  const geolocate = () => {
    navigator.geolocation.getCurrentPosition((res) => {
      const result = {
        lat: res.coords.latitude,
        lng: res.coords.longitude,
      };
      const closestStore = sortStores(result, stores)[0];
      const distance = getDistance(
        [closestStore.latitude, closestStore.longitude],
        [res.coords.latitude, res.coords.longitude]
      );
      switch (true) {
        case distance <= 50000:
          setDefaultZoom(11);
          setCoords(result);
          break;
        default:
          setSearchError(true);
          setDefaultZoom(10);
          setCoords(result);
          break;
      }
      setSortCoords(result);
    });
  };
  return (
    <>
      <SearchBarWrapper>
        <SearchBarInnerWrapper>
          <SearchBarContainer>
            <FindMyLocationWrapper>
              <TargetIcon
                onClick={() => {
                  geolocate();
                  setToggleFilter(false);
                }}
              />
            </FindMyLocationWrapper>
            {size == "mobile" ? null : (
              <LocateWrapper>
                <LocateMeButton onClick={geolocate} />
              </LocateWrapper>
            )}

            <SearchShadow>
              <SearchBar
                viewPort="mobile"
                openFilter={() => setToggleFilter(true)}
                setSearchError={setSearchError}
              />
            </SearchShadow>
          </SearchBarContainer>
        </SearchBarInnerWrapper>
      </SearchBarWrapper>

      {toggleFilter ? (
        <FilterWrapper>
          <FilterContainer>
            {searchError ? (
              <>
                <CardHeaderWrapper>
                  <CardHeader>
                    {lang("modal.no_nearby", window.data?.language || "en")}
                  </CardHeader>
                </CardHeaderWrapper>
                <CardContentWrapper>
                  {lang("modal.no_nearby_desc", window.data?.language || "en")}
                </CardContentWrapper>
                <CardContentWrapper>
                  {lang("modal.showing_nearby", window.data?.language || "en")}
                </CardContentWrapper>
                <CardButtonWrapper>
                  <CardButton onClick={() => setSearchError(false)}>
                    {lang("modal.ok", window.data?.language || "en")}
                  </CardButton>
                </CardButtonWrapper>
              </>
            ) : null}
            {!searchError && currentStore && showStore ? (
              <MobileStoreCard
                currentStore={currentStore}
                closeStore={() => {
                  setCurrentStore(undefined);
                  setShowStore(false);
                  setToggleFilter((toggleFilter) => !toggleFilter);
                }}
                fromFilter={fromFilter}
                back={() => {
                  setCurrentStore(undefined);
                  setShowStore(false);
                  setFromFilter(false);
                }}
              />
            ) : !searchError ? (
              <>
                <FilterHeader
                  onClick={(e) => {
                    setShowResults((showResults) => !showResults);
                    setShowBusinessTypes(false);
                    setShowProductTypes(false);
                  }}>
                  <FilterTitle>
                    {lang(
                      "filters.filterHeaders.all_locations",
                      window.data?.language || "en"
                    )}
                  </FilterTitle>
                  {showResults ? <MinusIcon /> : <PlusIcon />}
                </FilterHeader>
                {showResults ? (
                  <MobileResultsList
                    onClick={(store: Store) => {
                      setCurrentStore(store);
                      setShowStore(true);
                      setFromFilter(true);
                    }}
                  />
                ) : null}
                <FilterHeader
                  onClick={() => {
                    setShowResults(showProductTypes);
                    setShowProductTypes(
                      (showProductTypes) => !showProductTypes
                    );
                    setShowBusinessTypes(false);
                  }}>
                  <FilterTitle>
                    {lang(
                      "filters.filterHeaders.product",
                      window.data?.language || "en"
                    )}
                  </FilterTitle>
                  <NotifWrapper>
                    {productFiltersGlobal.length > 0 ? (
                      <Notif>{productFiltersGlobal.length}</Notif>
                    ) : null}
                    {showProductTypes ? <MinusIcon /> : <PlusIcon />}
                  </NotifWrapper>
                </FilterHeader>
                {showProductTypes ? (
                  <MobileFilterTemplate
                    handleFormChange={handleProductFormChange}
                    activeFilters={productFiltersGlobal}
                    isMobile={false}
                    filters={window.data?.products.map((p: string) => ({
                      value: p,
                      label: lang(
                        `filters.products.${p}`,
                        window.data?.language || "en"
                      ),
                    }))}
                    type={"product"}
                  />
                ) : null}
                <FilterHeader
                  onClick={(e) => {
                    setShowResults(showBusinessTypes);
                    setShowBusinessTypes(
                      (showBusinessTypes) => !showBusinessTypes
                    );
                    setShowProductTypes(false);
                  }}>
                  <FilterTitle>
                    {lang(
                      "filters.filterHeaders.businessType",
                      window.data?.language || "en"
                    )}
                  </FilterTitle>
                  <NotifWrapper>
                    {businessFiltersGlobal ? (
                      <NotifBus>
                        {businessFiltersGlobal === "airbnb" ? (
                          <AirbnbResults />
                        ) : businessFiltersGlobal === "hotel" ? (
                          <HotelResults />
                        ) : (
                          <StoreResults />
                        )}
                      </NotifBus>
                    ) : null}
                    {showBusinessTypes ? <MinusIcon /> : <PlusIcon />}
                  </NotifWrapper>
                </FilterHeader>
                {showBusinessTypes ? (
                  <MobileFilterTemplate
                    handleFormChange={handleBusinessFormChange}
                    filters={window.data?.businessTypes.map((p: string) => ({
                      value: p,
                      label: lang(
                        `filters.businessTypes.${p}`,
                        window.data?.language || "en"
                      ),
                    }))}
                    activeFilters={
                      businessFiltersGlobal !== undefined
                        ? [businessFiltersGlobal]
                        : []
                    }
                    type={"business"}
                  />
                ) : null}
              </>
            ) : null}
          </FilterContainer>
        </FilterWrapper>
      ) : null}

      <CircularFilterWrapper
        onClick={() => {
          setToggleFilter((preValue) => !preValue);
        }}>
        <CircularFilterIcon>
          {toggleFilter || selectedStore ? <XIconWhite /> : <FiltersIcon />}
        </CircularFilterIcon>
      </CircularFilterWrapper>
    </>
  );
};

const CardHeaderWrapper = styled.div`
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #c0bebe;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const CardHeader = styled.h4`
  margin: 0;
  font-weight: 800;
  font-size: 18px;
  letter-spacing: -0.5px;
  color: #522398;
`;

const CardContentWrapper = styled.div`
  padding: 1rem 1.5rem;
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  ::-webkit-scrollbar {
    border-radius: 30px;
  }
  text-align: center;
`;

const CardButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem;
`;

const CardButton = styled.button`
  border-radius: 36px;
  background-color: #522398;
  color: #fff;
  width: 68px;
  font-size: 11px;
  height: auto
  outline: none;
  border: none;
  font-family: inherit;
  font-weight: 600;
  letter-spacing: 0.5px;
  line-height: 1.38;
  padding: 0.6rem 1.6rem;
  text-align:center;
  justify-content:center;
  display:flex;
`;

const NotifWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: center;
`;

const Notif = styled.span`
  background-color: #522398;
  border-radius: 50%;
  color: white;
  height: 1.3rem;
  width: 1.3rem;
  text-align: center;
  justify-content: center;
  align-items: center;
  margin-right: 1rem;
`;

const NotifBus = styled.span`
  height: auto;
  width: auto;
  text-align: center;
  justify-content: center;
  align-items: center;
  margin-right: 1rem;
`;
